<template>
<div>
    <!-- modal -->
    <b-modal id="trademarkDetailFormModal" centered size="lg" no-close-on-backdrop ref="trademarkDetailFormModal" :title="$t('trademarkDetail.info')" hide-footer @hide="onModalHide">

        <!-- Language Switcher in Header -->
        <template #modal-header="{ close }">
            <h5 class="modal-title">{{ $t('trademarkDetail.info') }}</h5>
            <div class="d-flex align-items-center">
                <b-nav-item-dropdown id="trademark-lang-dropdown" variant="link" class="dropdown-language mr-2" right>
                    <template #button-content>
                        <b-img :src="currentLocale.img" height="14px" width="22px" :alt="currentLocale.locale" />
                        <span class="ml-50 text-body">{{ currentLocale.name }}</span>
                    </template>
                    <b-dropdown-item v-for="localeObj in locales" :key="localeObj.locale" @click="changeLanguage(localeObj.locale)">
                        <b-img :src="localeObj.img" height="14px" width="22px" :alt="localeObj.locale" />
                        <span class="ml-50">{{ localeObj.name }}</span>
                    </b-dropdown-item>
                </b-nav-item-dropdown>
                <button type="button" class="close" @click="close()">×</button>
            </div>
        </template>
        <table class="styled-table">
            <tbody v-for="(selectedElementsValue, selectedElementsKey) in selectedElements" :key="selectedElementsKey">
                <tr v-for="(value, key) in selectedElementsValue" :key="key" v-if="key !== 'clientAccountingId'">
                    <td>{{ $t(`trademarkDetail.${key}`) }}</td>
                    <td>
                        <img v-if="key === 'image'" :src="value" alt="Trademark Logo" style="max-width: 100px; max-height: 100px;" />
                        <span v-else>{{ value }}</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </b-modal>
</div>
</template>

<script>
import {
    BNavItemDropdown,
    BDropdownItem,
    BImg
} from 'bootstrap-vue'
import {
    localize
} from 'vee-validate'

export default {
    components: {
        BNavItemDropdown,
        BDropdownItem,
        BImg,
    },
    data() {
        return {
            selectedElements: [],
            previousLanguage: 'tr', // stores language before modal opens
            locales: [{
                    locale: 'tr',
                    img: require('@/assets/images/flags/tr.png'),
                    name: 'Türkçe',
                },
                {
                    locale: 'en',
                    img: require('@/assets/images/flags/en.png'),
                    name: 'English',
                },
            ],
        }
    },
    computed: {
        currentLocale() {
            return this.locales.find(l => l.locale === this.$i18n.locale)
        },
    },
    methods: {
        changeLanguage(value) {
            this.$i18n.locale = value
            sessionStorage.setItem('language', value)
            sessionStorage.setItem('languageValue', value)
            localize(value)
        },
        onModalHide() {
            // Restore the language that was active before the modal opened
            this.changeLanguage(this.previousLanguage)
        },
        formatLongDate(date) {
            if (date == null) return '-';
            const d = new Date(date);
            if (isNaN(d.getTime()) || d.getFullYear() <= 1) return '-';
            const lang = this.$i18n.locale || 'tr';
            if (lang === 'en') {
                return d.toLocaleDateString('en-US', {
                    month: 'long',
                    day: '2-digit',
                    year: 'numeric'
                });
            } else {
                return d.toLocaleDateString('tr-TR', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric'
                });
            }
        },
        async showInfo(trademarkDetailObject) {
            // Save current language before switching to English
            this.previousLanguage = this.$i18n.locale
            this.changeLanguage('en')

            this.selectedElements = []
            this.rows = []
            const data = {
                id: trademarkDetailObject[0].id
            }
            const controller = {
                name: 'TrademarkOwner',
                actionName: 'GetTrademarkOwnerListByTrademarkId'
            }
            const payload = {
                data: data,
                controller: controller
            }
            await this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    response.data.trademarkOwnerList.forEach(element => {
                        this.rows.push(element)
                    })
                }
            })
            this.$refs['trademarkDetailFormModal'].show()
            trademarkDetailObject.forEach(element => {
                if (element != '') {
                    this.selectedElements.push({
                        clientAccountingId: element.clientAccountingId,
                        trademark: element.trademark,
                        image: 'data:image/jpeg;base64,'.concat(element.logo),
                        representative: element.agent,
                        trademarkOwner: element.owner,
                        applicationNumber: element.applicationNo,
                        applicationDate: this.formatLongDate(element.applicationDate),
                        priorityDate: this.formatLongDate(element.priorityDate),
                        registrationNo: element.registrationNo,
                        registrationDate: this.formatLongDate(element.registrationDate),
                        classes: element.niceClass,
                        status: element.trademarkStatus,
                        nextRenewalDate: this.formatLongDate(element.nextRenewalDate),
                        stockReference: element.recordNo
                    });
                } else this.selectedElements = []
            });
        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.styled-table {
    width: 100%;
    table-layout: fixed;
}

.styled-table td,
.styled-table th {
    word-wrap: break-word;
    padding: 0.5rem;
    text-align: left;
}
</style>
